export const HISTORY_GOALS_TITLES = {
  saving_goal_changed: 'updated savings goal.'
}
